<template>
  <div class="page"
       v-bind:class="{
          'page--overlay' : initialData.overlayMenu,
          'page--auth-overlay' : isActiveOverlayLogin
       }">

    <Header></Header>

    <div class="instr-wrap">

      <div class="instr-section">
        <div class="instr-l-title">
          MOBICAR 3 Сompact
        </div>
        <div class="instr-p">
          Для автомобильной охранной системы Mobicar 3 Сompact доступно управление автомобилем через мобильное приложение,
          по каналам связи Bluetooth и GSM и при помощи штатного брелока автомобиля.
          Дополнительно вы можете приобрести фирменный брелок для управления устройством по радио.
          <br>
          <br>
          Система Mobicar 3 Сompact позволяет получать оповещения непосредсвенно на ваш телефон путем смс,
          звонка от автомобиля и push-уведомлений от приложения.
        </div>
        <div class="instr-m-title">
          Мобильное приложение
        </div>
        <div class="instr-mob-apps">
          <div class="instr-mob-apps_item">
            <img src="@/assets/img/instructions/qr-app-store.svg">
          </div>
          <a href="/app/ios/skauto" target="_blank"  class="instr-mob-apps_item">
            <img src="@/assets/img/instructions/app-store.svg">
            <div>
              iPhone и iPad
            </div>
          </a>
          <a href="https://play.google.com/store/apps/details?id=megaf.auto" target="_blank" class="instr-mob-apps_item">
            <img src="@/assets/img/instructions/google-play.svg">
            <div>
              Android
            </div>
          </a>
          <div class="instr-mob-apps_item">
            <img src="@/assets/img/instructions/qr-google-play.svg">
          </div>
        </div>
        <div class="instr-m-title">
          Сопряжение MOBICAR 3 Сompact с мобильным устройством по Bluetooth
        </div>
        <div class="instr-clarification">
          Мобильное устройство может работать с системой только после выполнения процедуры сопряжения.
        </div>
        <div class="instr-clarification">
          Система может работать с 2 мобильными устройствами, добавленными в рамках одной процедуры сопряжения. При повторном сопряжении с новыми мобильными устройствами все ранее сопряжённые устройства удаляются из памяти MOBICAR 3 Сompact.
        </div>
        <div class="instr-s-title">
          Создание личного кабинета:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/screen01.jpg">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1
              </div>
              Запустите мобильное приложение.<br>
              Если у вас еще нет аккаунта - зарегистрируйтесь.
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/screen02.jpg">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2
              </div>
              Введите адрес Вашей электронной почты и пароль, которые будет в последствии использоваться для входа в личный кабинет. Нажмите кнопку: “Зарегистрировать”
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/screen03.jpg">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                3
              </div>
              На указанный адрес электронной почты, будет отправлено письмо. Для завершения регистрации перейдите по ссылке, содержащейся в теле письма.
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/screen04.jpg">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                4
              </div>
              Создание личного кабинета завершено.<br>
              Вы можете приступить к подключению автомобиля.
            </div>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-s-title">
          Сопряжение мобильного устройства с Mobicar 3 Сompact
        </div>
        <div class="instr-clarification">
          Убедитесь, что автомобиль снят с охраны.
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/antenna_module.png">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1
              </div>
              Нажмите на 2 сек. кнопку антенного модуля. До звукового сигнала
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/antenna_module.png">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2
              </div>
              Нажмите коротко кнопку антенного модуля (в подтверждение нажатия, после того как кнопка отпущена антенный модуль подаст звуковой сигнал).
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/screen05.jpg">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                3
              </div>
              Введите в мобильном устройстве код подключения Bluetooth с карточки пользователя.
            </div>
          </div>
        </div>
        <div class="instr-p">
          В течение двух минут можно подключить дополнительные мобильные устройства, используя тот же 6-значный код. По окончании этого времени процедура сопряжения завершится автоматически.
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-m-title">
          Аварийное выключение режима охраны
        </div>
        <div class="instr-clarification">
          Аварийное снятие с охраны, когда недоступен брелок и нет возможности воспользоваться телефоном и войти в личный кабинет, производится вводом PIN-кода на антенном модуле.
        </div>
        <div class="instr-p">
          Для аварийного снятия с охраны выполните следующие действия:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/car_open-doors.png">
            </div>
            <div class="instr-list_params">
              <div class="instr-list_param">
                Откройте дверь автомобиля для доступа к антенному модулю механическим ключом.
              </div>
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/screen05.jpg">
            </div>
            <div class="instr-list_params">
              <div class="instr-list_param">
                Введите PIN-код
              </div>
              <div class="instr-list_param instr-list_param__annotation">
                Код вводится на антенном модуле. Количество кликов соответствует цифре кода. После ввода одной цифры модуль подаст звуковой сигнал. Далее можно вводить следующую цифру кода.
              </div>
              <div class="instr-list_param instr-list_param__annotation">
                Пользователь может изменить PIN в настройках системы.
              </div>
              <div class="instr-list_param instr-list_param__annotation">
                Заводской PIN-код указан на тыльной стороне карты пользователя, которая входит в комплект поставки системы. Пользователь может изменить PIN в настройках системы.
              </div>
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/car_two-signal.png">
            </div>
            <div class="instr-list_params">
              <div class="instr-list_param">
                Тревога прекратится.
              </div>
              <div class="instr-list_param">
                Автомобиль подаст два коротких звуковых сигнала,<br>
                Аварийная сигнализация мигнёт два раза,<br>
                Блокировка двигателя выключится,<br>
                Замки дверей разблокируются.
              </div>
              <div class="instr-list_param instr-list_param__attention">
                Если PIN-код введён неверно, снятия с охраны не произойдёт.<br>
                Антенный модуль оповестит об этом тремя звуковыми сигналами
              </div>
              <div class="instr-list_param instr-list_param__annotation">
                Повторить ввод PIN-кода можно через 30 секунд.
              </div>
              <div class="instr-list_param instr-list_param__attention">
                Если PIN-код введён некорректно 3 раза, экстренное отключение охраны блокируется на 30 минут.
              </div>
            </div>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-m-title">
          Управление системой при помощи антенного модуля
        </div>
        <div class="instr-clarification">
          Управлять некоторыми функциями системы можно с помощью антенного модуля.
        </div>
        <div class="instr-clarification">
          На антенном модуле предусмотрена одна кнопка и индикатор.
        </div>
        <div class="instr-clarification instr-clarification__attention">
          После каждого ввода кода функции или цифры PIN-кода дождитесь звукового сигнала
        </div>

        <div class="m3l-cmd">
          <div class="m3l-cmd_head">
            <div class="m3l-cmd_head-func">
              <div class="m3l-cmd_head-item">
                Функция
              </div>
              <div class="m3l-cmd_head-item">
                Команда
              </div>
            </div>
            <div class="m3l-cmd_head_actions">
              <div class="m3l-cmd_head-item">
                Последовательность действий
              </div>
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Вызов водителя автомобиля
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Короткое нажатие кнопки антенного модуля, с последующим коротким звуковым сигналом
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Аварийное выключение охраны
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-symbol">n*</span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Введите PIN код системы
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Сопряжение системы с мобильным устройством
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Длительное и короткое нажатия, с последующим звуковым сигналом → Сопряжение с мобильным устройством
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Регистрация брелоков в памяти системы
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dot"></span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Длительное и два коротких нажатия → PIN → нажать кнопку брелока
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Регистрация меток в памяти системы
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dot"></span>
                <span class="m3l-cmd_morse-dot"></span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Длительное и три коротких нажатия → PIN → нажать долго кнопку метки, затем нажать кнопку  метки  коротко три раза
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Вкл./выкл. режим Автосервис
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Два длительных и короткое нажатие → PIN
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Меню CAN-прошивки
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dot"></span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Два длительных и два коротких нажатия
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Изменение PIN-кода
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Три длительных и короткое нажатие → PIN → PIN новый***
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Программирование тахометрического сигнала
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dot"></span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Три длительных и два оротких нажатия
            </div>
          </div>
          <div class="m3l-cmd_row">
            <div class="m3l-cmd_func">
              <div class="m3l-cmd_name">
                Обучение иммобилайзера
              </div>
              <div class="m3l-cmd_morse">
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dash"></span>
                <span class="m3l-cmd_morse-dot"></span>
                <span class="m3l-cmd_morse-dot"></span>
                <span class="m3l-cmd_morse-dot"></span>
              </div>
            </div>
            <div class="m3l-cmd_actions">
              Три длительных и три коротких нажатия
            </div>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-m-title">
          Управление системой посредством звонка на номер системы
        </div>
        <div class="instr-clarification">
          При звонке на номер телефона системы с зарегистрированных в памяти системы номеров телефонов, MOBICAR 3 Сompact сообщает текущее состояние и номера доступных команд. Для выполнения команды нажмите нужную цифру на клавиатуре телефона и PIN код системы.
        </div>

        <div class="m3l-call-cmd">
          <div class="m3l-call-cmd_head">
            <div class="m3l-call-cmd_head-item">
              №
            </div>
            <div class="m3l-call-cmd_head-item">
              Функция
            </div>
          </div>
          <div class="m3l-call-cmd_row"
               v-for="item in m3lCall">
            <div class="m3l-call-cmd_index">
              {{item.index}}
            </div>
            <div class="m3l-call-cmd_name">
              {{item.name}}
              <div class='m3l-call-cmd_name-desc'
                   v-if="item.desc">
                {{item.desc}}
              </div>
            </div>
          </div>
        </div>

        <div class="m3l-call-cmd m3l-call-cmd__desc">
          <div class="m3l-call-cmd_cnt">
            <div class="m3l-call-cmd_head">
              <div class="m3l-call-cmd_head-item">
                №
              </div>
              <div class="m3l-call-cmd_head-item">
                Функция
              </div>
            </div>
            <div class="m3l-call-cmd_row"
                 v-if="item.index.indexOf(0) === -1"
                 v-for="item in m3lCall">
              <div class="m3l-call-cmd_index">
                {{item.index}}
              </div>
              <div class="m3l-call-cmd_name">
                {{item.name}}
                <div class='m3l-call-cmd_name-desc'
                     v-if="item.desc">
                  {{item.desc}}
                </div>
              </div>
            </div>
          </div>
          <div class="m3l-call-cmd_cnt">
            <div class="m3l-call-cmd_head">
              <div class="m3l-call-cmd_head-item">
                №
              </div>
              <div class="m3l-call-cmd_head-item">
                Функция
              </div>
            </div>
            <div class="m3l-call-cmd_row"
                 v-if="item.index.indexOf(0) > -1"
                 v-for="item in m3lCall">
              <div class="m3l-call-cmd_index">
                {{item.index}}
              </div>
              <div class="m3l-call-cmd_name">
                {{item.name}}
                <div class='m3l-call-cmd_name-desc'
                     v-if="item.desc">
                  {{item.desc}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          РУКОВОДСТВО ПО ЭКСПЛУАТАЦИИ<br>
          SCHER-KHAN X-TAG
        </div>
        <div class="instr-m-title">
          Установка элемента питания метки
        </div>
        <div class="instr-clarification">
          Перед эксплуатацией метки необходимо задействовать установленный в ней элемент питания.
        </div>
        <div class="instr-s-title">
          Для задействования элемента питания метки выполните следующие действия:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_img instr-list_img__big">
              <img src="@/assets/img/instructions/xtag/battary.jpg">
            </div>
            <div class="instr-list_params">
              <div class="instr-list_text">
                1. Откройте крышку батарейного отсека, расположенную на тыльной стороне метки
              </div>
              <div class="instr-list_text">
                2. Извлеките из-под установленного элемента питания изолирующую прокладку
              </div>
              <div class="instr-list_text">
                3. Закройте крышку батарейного отсека. Метка готова к работе
              </div>
            </div>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          НАЗНАЧЕНИЕ МЕТКИ
        </div>
        <div class="instr-s-title">
          Метка SCHER-KHAN X-Tag предназначена для:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1.
              </div>
              Управления системой SCHER-KHAN MOBICAR 3 Compact, MOBICAR 3 Light, X1, X2, X2M, X4, X6, T1,
              T2. Осуществления постановки на охрану, снятия с охраны, дистанционного запуска двигателя с
              помощью кнопки
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2.
              </div>
              Автоматического включения режима охраны и автоматического выключения режима охраны
              при удалении и приближении к автомобилю (функции системы «Автопостановка» и
              «Автоснятие»)
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                3.
              </div>
              Обеспечения дополнительного уровня защиты автомобиля (функция системы «Иммобилайзер»)
            </div>
          </div>
        </div>
        <div class="instr-p">
          Обмен информацией между меткой и системой возможен по беспроводному соединению Bluetooth
          (только в непосредственной близости от автомобиля).
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          ФУНКЦИИ КНОПКИ МЕТКИ
        </div>
        <div class="instr-list_item">
          <div class="instr-list_img">
            <img src="@/assets/img/instructions/xtag/button-tag.jpg">
          </div>
          <div>
            <table border="1px solid black" class="instr-table">
              <thead>
              <tr>
                <th>
                  Функция метки
                </th>
                <th>
                  Необходимые условия
                </th>
                <th>
                  Длительность нажатия
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  Включение охраны
                </td>
                <td>
                  Охрана выключена
                </td>
                <td rowspan="3">1 сек.</td>
              </tr>
              <tr>
                <td>
                  Выключение охраны
                </td>
                <td>
                  Охрана включена
                </td>
              </tr>
              <tr>
                <td>
                  Выключение режима тревоги
                </td>
                <td>
                  Режим тревоги включен
                </td>
              </tr>

              <tr>
                <td>
                  Автоматический запуск
                  двигателя
                </td>
                <td>
                  Двигатель выключен. <br>
                  Подготовка к запуску для МКПП выполнена
                </td>
                <td rowspan="6">
                  2 сек., два раза
                </td>
              </tr>
              <tr>
                <td>Завершение автозапуска </td>
                <td>Автозапуск выполняется</td>
              </tr>
              <tr>
                <td>Включение охраны с работающим двигателем </td>
                <td>Двигатель включен вручную</td>
              </tr>
              <tr>
                <td>Выключение охраны с работающим двигателем</td>
                <td>Охрана с работающим двигателем включена</td>
              </tr>
              <tr>
                <td>Выключение режима «Турботаймер»</td>
                <td>Режим «Турботаймер» включен</td>
              </tr>
              <tr>
                <td>Выключение подготовки к запуску</td>
                <td>Подготовка к запуску выполняется</td>
              </tr>
              <tr>
                <td>
                  Регистрация метки в памяти
                  системы
                </td>
                <td>
                  Охрана выключена
                </td>
                <td>
                  2 сек., затем три
                  раза 1 сек.
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          РЕГИСТРАЦИЯ МЕТКИ В ПАМЯТИ СИСТЕМЫ
        </div>
        <div class="instr-clarification">
          Система работает только с теми метками, которые зарегистрированы в её памяти.
        </div>
        <div class="instr-clarification">
          Система может работать одновременно с 2 метками, добавленными в рамках одной процедуры сопряжения. При
          повторном сопряжении с новыми метками все ранее сопряжённые метки удаляются из памяти системы.
        </div>
        <div class="instr-s-title">
          Для регистрации метки выполните следующие действия:
        </div>

        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1.
              </div>
              Убедитесь, что охрана выключена
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2.
              </div>
              Нажмите кнопку на антенном модуле (кнопку-индикатор) до подачи звукового сигнала
              (удерживайте не менее 2-х сек.)
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                3.
              </div>
              Три раза коротко нажмите кнопку на антенном модуле (кнопку-индикатор), в подтверждение
              каждого нажатия, после того как кнопка отпущена антенный модуль (основной блок) подаст
              звуковой сигнал
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                4.
              </div>
              Прозвучит 1 короткий звуковой сигнал антенного модуля (основного блока). Индикатор на
              антенном модуле (кнопка-индикатор) начнет быстро мигать
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                5.
              </div>
              Введите PIN-код. Для этого нажмите кнопку на антенном модуле (кнопку-индикатор) количество
              раз, соответствующее первой цифре PIN-кода, и ожидайте звукового сигнала. Через 5 секунд
              антенный модуль (основной блок) звуковым сигналом оповестит о готовности к вводу
              следующей цифры. Введите таким же образом оставшиеся цифры PIN-кода
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                6.
              </div>
              Прозвучит 1 короткий звуковой сигнал антенного модуля (основного блока). Индикатор на
              антенном модуле (кнопка-индикатор) начнет быстро мигать
            </div>
          </div>
          <div class="instr-list_param instr-list_param__attention"
               style="margin-top: -20px">
            Если PIN-код введён неверно, индикатор не загорится, а антенный модуль (основной блок) подаст 3
            звуковых сигнала. Необходимо повторить действия, начиная с пункта 2.
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                7.
              </div>
              Вытащите батарейку метки на 5 сек. и установите ее вновь.<br>
              Нажмите длительно (удерживайте не менее 2-х сек.) кнопку на регистрируемой метке. Затем три
              раза коротко нажмите кнопку на регистрируемой метке. Индикатор на метке начнёт
              попеременно мигать синим и красным цветом. В подтверждение успешной регистрации метки
              прозвучит 1 короткий звуковой сигнал антенного модуля (основного блока)
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                8.
              </div>
              Если регистрируются две метки, то после регистрации первой, аналогично переведите вторую метку в режим сопряжения как указано в пункте <b>7</b>.
            </div>
          </div>
        </div>
        <div class="instr-clarification">
          Заводской PIN-код указан на тыльной стороне карты пользователя, которая входит в комплект
          поставки системы
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          ОБНОВЛЕНИЕ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ МЕТКИ
        </div>
        <div class="instr-s-title">
          Для обновления программного обеспечения метки выполните следующие действия:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1.
              </div>
              Откройте крышку батарейного отсека, расположенную на тыльной стороне метки. Извлеките
              элемент питания из метки, нажмите и удерживайте кнопку метки
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2.
              </div>
              Установите элемент питания обратно, удерживая при этом нажатой кнопку. Отпустите кнопку.
              Закройте крышку батарейного отсека
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/xtag/screen01.jpg">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                3.
              </div>
              Запустите на мобильном устройстве мобильное приложение SCHER-KHAN AUTO. Во вкладке
              «Настройки» выберите пункт «Обновление прошивки устройства»
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_img">
              <img src="@/assets/img/instructions/xtag/screen02.jpg">
            </div>
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                4.
              </div>
              Мобильное приложение автоматически обнаружит метку, готовую к обновлению программного
              обеспечения и начнёт обновление
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                5.
              </div>
              Дождитесь завершения обновления программного обеспечения метки. Метка готова к работе
            </div>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          ТЕХНИЧЕСКИЕ ХАРАКТЕРИСТИКИ
        </div>
        <table class="instr-table">
          <tr>
            <td rowspan="2">
              Параметр
            </td>
            <td colspan="2">
              Значение
            </td>
          </tr>
          <tr>
            <td>
              Мин.
            </td>
            <td>
              Макс.
            </td>
          </tr>
          <tr>
            <td>Метка</td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td>Несущая частота радиоканала (ГГц)</td>
            <td colspan="2">2,4</td>
          </tr>
          <tr>
            <td>Протокол связи</td>
            <td colspan="2">Bluetooth 5.0</td>
          </tr>
          <tr>
            <td>Элемент питания метки</td>
            <td colspan="2">3 В (батарея CR2032)</td>
          </tr>
          <tr>
            <td>Диапазон рабочих температур (°С)</td>
            <td>0</td>
            <td>+40</td>
          </tr>
          <tr>
            <td>Исполнение корпуса</td>
            <td colspan="2">IP-64</td>
          </tr>
        </table>

        <div style="height: 30px">
        </div>
      </div>

      <Footer></Footer>
    </div>

  </div>
</template>

<script>
import Header from '@/components/Initial/Header.vue'
import Footer from '@/components/Initial/Footer.vue'

export default {
  data(){
    return{
      m3lCall : [
        {
          index : '1',
          name : 'Поставить на охрану'
        },
        {
          index : '01',
          name : 'Закрыть центральный замок'
        },
        {
          index : '2',
          name : 'Снять с охраны',
          desc : 'требуется PIN-код'
        },
        {
          index : '02',
          name : 'Открыть центральный замок'
        },
        {
          index : '3',
          name : 'Завести двигатель'
        },
        {
          index : '03',
          name : 'Выключить двигатель'
        },
        {
          index : '4',
          name : 'Отпереть багажник'
        },
        {
          index : '04',
          name : 'Запереть багажник'
        },
        {
          index : '5',
          name : 'Включить подогреватель'
        },
        {
          index : '05',
          name : 'Выключить подогреватель'
        },
        {
          index : '6',
          name : 'Перейти в сервисный режим',
          desc : 'требуется PIN-код'
        },
        {
          index : '06',
          name : 'Выключить сервисный режим',
        },
        {
          index : '7',
          name : 'Разрешить поездку',
          desc : 'требуется PIN-код'
        },
        {
          index : '8',
          name : 'Включить сигнал',
        },
        {
          index : '#',
          name : 'Завершить вызов',
        },
      ]
    }
  },
  mounted() {
    if( this.initialPage ){
      this.$store.dispatch('toggleInitialPage');
    }
  },
  computed : {
    initialPage() {
      return this.$store.state.initialPage;
    },
    initialData : function (){
      return this.$store.state.initial
    },
    isActiveOverlayLogin(){
      return this.$store.state.panels.login.status
    },
  },
  components: {
    Header,
    Footer
  },
}
</script>